var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReduce03(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 122,
    viewBox: "0 0 121 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0869 110.979V35.023C24.0869 22.5966 34.2421 12.523 46.6685 12.523V12.523C59.0949 12.523 69.2501 22.5966 69.2501 35.023V39.1693",
    stroke: "white",
    strokeWidth: 4.8174,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3159 59.0411C87.3159 48.3156 78.6212 39.6209 67.8957 39.6209C57.1703 39.6209 48.4756 48.3156 48.4756 59.0411",
    stroke: "white",
    strokeWidth: 4.8174
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4102 59.9443H92.7347",
    stroke: "white",
    strokeWidth: 4.8174,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8105 71.2351V76.6547M52.9912 71.2351V76.6547M85.5087 71.2351V76.6547",
    stroke: "white",
    strokeWidth: 4.8174,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8105 86.5906V92.0102M52.9912 86.5906V92.0102M85.5087 86.5906V92.0102",
    stroke: "white",
    strokeWidth: 4.8174,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReduce03);
export default __webpack_public_path__ + "static/media/reduce-03.28bbe1d6c987dbdb3fdfb76a70ede138.svg";
export { ForwardRef as ReactComponent };